(function(){
  "use strict";
  var FT="_sth_ft", LT="_sth_lt", VID="_sth_vid", FT_DAYS=180, VID_DAYS=730;

  function consentOK(){
    try{ var cp = window.Shopify && window.Shopify.customerPrivacy;
         if(cp && typeof cp.analyticsProcessingAllowed==="function")
           return cp.analyticsProcessingAllowed() !== false;
    }catch(e){}
    return true; // US base / legitimate interest default; explicit deny short-circuits above
  }
  function getCookie(n){var m=document.cookie.match('(?:^|; )'+n+'=([^;]*)');return m?decodeURIComponent(m[1]):null;}
  function setCookie(n,v,days){var d=new Date();d.setTime(d.getTime()+days*864e5);
    document.cookie=n+"="+encodeURIComponent(v)+";expires="+d.toUTCString()+";path=/;SameSite=Lax;Secure";}
  function uuid(){return (window.crypto&&crypto.randomUUID)?crypto.randomUUID():
    'xxxxxxxxyxxxxxxx'.replace(/[xy]/g,function(c){var r=Math.random()*16|0;return (c==='x'?r:(r&0x3|0x8)).toString(16);});}

  if(!consentOK()) return;

  var qs=new URLSearchParams(location.search);
  var touch={
    source:qs.get("utm_source")||"", medium:qs.get("utm_medium")||"",
    campaign:qs.get("utm_campaign")||"", content:qs.get("utm_content")||"",
    ts:new Date().toISOString(), referrer:document.referrer||"",
    landing:location.pathname+location.search
  };

  var vid=getCookie(VID); if(!vid){vid=uuid();setCookie(VID,vid,VID_DAYS);}

  var hasSource = !!touch.source || (touch.referrer && touch.referrer.indexOf(location.host)===-1);
  if(!getCookie(FT) && hasSource) setCookie(FT, JSON.stringify(touch), FT_DAYS);
  if(hasSource) setCookie(LT, JSON.stringify(touch), FT_DAYS);

  function attrs(){
    var ft=null, lt=null;
    try{ ft=JSON.parse(getCookie(FT)||"null"); }catch(e){}
    try{ lt=JSON.parse(getCookie(LT)||"null"); }catch(e){}
    ft=ft||touch; lt=lt||ft;
    return {
      "_utm_source":ft.source, "_utm_medium":ft.medium,
      "_utm_campaign":ft.campaign, "_utm_content":ft.content,
      "_landing_url":ft.landing, "_referrer":ft.referrer,
      "_first_touch_ts":ft.ts, "_visitor_id":vid,
      "_last_source":lt.source, "_last_medium":lt.medium, "_last_content":lt.content
    };
  }
  function flush(){
    return fetch("/cart/update.js",{method:"POST",headers:{"Content-Type":"application/json"},
      body:JSON.stringify({attributes:attrs()})}).catch(function(){});
  }

  window.Stienhardt = window.Stienhardt || {};
  window.Stienhardt.attribution = { attrs:attrs, flush:flush, visitorId:vid };

  // flush now if a cart already exists (returning shopper); otherwise the add-to-cart
  // handlers (incl. the diamond path) should call window.Stienhardt.attribution.flush().
  if(getCookie("cart")) flush();
})();
